import React from 'react'
import styled from 'styled-components'
// @ts-ignore
import { sys } from '@netbasequid/theme'
import { Theme } from 'features/ui/types'
import { StreamData } from 'types/streamData'
import { useDisplayTheme } from 'hooks/useUiState'
import { AUTO_ATTR_KEY, AutomationId } from 'utils/automationUtil'
import DirectionContentComponent from '../DirectionContentComponent'
import ContentComponent from './ContentComponent'
import AuthorNameAndHandle from '../HeaderInfo/AuthorNameAndHandle'
import { StyleAuthorContainer, StyledContent } from '../index.css'

const StyledQuoteContainer = styled.div.attrs({
  [AUTO_ATTR_KEY]: AutomationId.soundbiteDefaultFrame.quote
})`
  width: 100%;
  box-sizing: border-box;
  height: auto;
  padding: 12px;
  border-radius: 2px;
  border: 1px solid ${({ mode }: { mode: Theme }) => sys[mode].common.divider[100]};
  margin-top: 12px;
  gap: 8px;
  display: flex;
  flex-direction: column;
  word-break: break-word;
`

type QuoteContentProps = {
  streamData: StreamData
}

const QuoteContent = ({ streamData }: QuoteContentProps) => {
  const theme = useDisplayTheme() as Theme
  const {
    originalAuthorUrl,
    originalAuthorName,
    originalAuthorHandle,
    originalAuthorVerified,
    parentText,
    isParentTextRtl
  } = streamData

  return (
    <StyledQuoteContainer mode={theme}>
      <StyleAuthorContainer>
        <AuthorNameAndHandle
          name={originalAuthorName!}
          handle={originalAuthorHandle!}
          url={originalAuthorUrl}
          verified={originalAuthorVerified}
        />
      </StyleAuthorContainer>
      <StyledContent mode={theme}>
        <DirectionContentComponent isRtl={isParentTextRtl}>
          <ContentComponent text={parentText!} />
        </DirectionContentComponent>
      </StyledContent>
    </StyledQuoteContainer>
  )
}

export default QuoteContent
